// import tim from '../../tim'

import {
  slide,
  announcement,
  navCategory,
  navCategoryPage,
  friendLinks,
  getAdv,
  getSite,
  credit,
  promote,
  education,
} from '@/api/index'


// import {  getToken, removeToken,removeUid,removeInfo } from '@/utils/auth'

const index = {
  state: {
    slideData: [],
    navCategoryListData: [], //协会动态列表数据存储

  },
  mutations: {

    slideDataList(state, groupList) {
      state.slideData = groupList
    },

    navCategoryListData(state, navCategoryListData) {
      state.navCategoryListData = navCategoryListData
    },



  },
  actions: {
    /**
     * 首页轮播图
     * @param {*} context 
     * @param {*} data 
     */
    slide({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        slide(userInfo).then(response => {
          const {
            data
          } = response;
          commit('slideDataList', data.data)
          resolve(data)


        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 首页公告
     * @param {*} context 
     * @param {*} data 
     */
    // announcement({commit }, userInfo) {
    //   return new Promise((resolve, reject) => {
    //     announcement(userInfo).then(response => {
    //       const { data } = response;

    //       resolve(data)


    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    /**
     * 首页NAV列表导航
     * @param {*} context 
     * @param {*} data 
     */
    navCategory({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        navCategory(data).then(response => {
          const {
            data
          } = response;
          //commit('navCategoryListData', response.data)
          //commit('navCategoryData', response.data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 导航列表详情页接口
     * @param {*} context 
     * @param {*} data 
     */
    navCategoryPage({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        navCategoryPage(data).then(response => {
          const {
            data
          } = response;
          if (response.data.data) {
            commit('navCategoryListData', response.data.data)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 首页友情链接接口
     * @param {*} context 
     * @param {*} data 
     */
    friendLinks({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        friendLinks(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 首页飘窗广告
     * @param {*} context 
     * @param {*} data 
     */
    getAdv({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        getAdv(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },


    /**
     * 网站基本信息
     * @param {*} context 
     * @param {*} data 
     */
    getSite({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        getSite(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },


    /**
     * 左侧继续教育
     * @param {*} param0 
     * @param {*} data 
     */
    education({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        education(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 左侧学历提升
     * @param {*} param0 
     * @param {*} data 
     */
    promote({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        promote(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 左侧学分查询
     * @param {*} param0 
     * @param {*} data 
     */
    credit({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        credit(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },



  }
}

export default index



// WEBPACK FOOTER //
// ./src/store/modules/index.js